document.addEventListener('alpine:init', () => {
  Alpine.data('ShopTheLook', () => ({
    showPopup: false,

    init() {
      // Add escape key handler
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.showPopup) {
          this.showPopup = false;
        }
      });
    },

    openPopup() {
      this.showPopup = true;
      document.body.classList.add('overflow-hidden');
    },

    closePopup() {
      this.showPopup = false;
      document.body.classList.remove('overflow-hidden');
    }
  }));
}); 